import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SmartRoot from "@/pages/SmartRoot";
import Registrati from "@/pages/Registrati";
import Login from "@/pages/Login";
import Privacy from "@/pages/Privacy";
import Termini from "@/pages/Termini";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import DashboardHome from "@/pages/dashboard/Home";
import Placeholder from "@/pages/dashboard/Placeholder";
import Lavori from "@/pages/dashboard/Lavori";
import JobDetail from "@/pages/dashboard/JobDetail";
import Preventivi from "@/pages/dashboard/Preventivi";
import QuoteDetail from "@/pages/dashboard/QuoteDetail";
import Impostazioni from "@/pages/dashboard/Impostazioni";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SmartRoot />} />

          <Route path="/registrati" element={<Registrati />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/termini" element={<Termini />} />
          <Route path="/app" element={<DashboardLayout />}>
            <Route index element={<DashboardHome />} />
            <Route path="lavori" element={<Lavori />} />
            <Route path="lavori/:jobId" element={<JobDetail />} />
            <Route path="preventivi" element={<Preventivi />} />
            <Route path="preventivi/:quoteId" element={<QuoteDetail />} />
            <Route path="impostazioni" element={<Impostazioni />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
